export default "__VITE_ASSET__BJekHYYy__"